import {useEffect, useMemo, useState} from 'react';
import {useTranslation} from 'react-i18next';
import {SvgIcon} from '@mui/material';
import {paths} from 'src/paths';
import {
    accountingDataRoute,
    aiChatDataRoute, iaImagesDataRoute, chartCategoryListRoute, chartImplementationListRoute, customChartRoute,
    dashboardBaseRoute, dashboardListRoute, dashboardNavForMobileRoute, dataGridImplementationListRoute,
    establishmentListRoute, productDataRoute,
    staffDataRoute,
    synchronisationRoute,
    turnOverDataRoute
} from "../../routes/dashboard";
import localStrings from "../../localStrings";
import useAuth from "../../hooks/useAuth";
import Houses from "../../icons/untitled-ui/duocolor/houses";
import Account from "../../icons/untitled-ui/duocolor/account";
import HomeSmile from "../../icons/untitled-ui/duocolor/home-smile";
import Users03 from "../../icons/untitled-ui/duocolor/users-03";
import CurrencyBitcoinCircle from "../../icons/untitled-ui/duocolor/currency-bitcoin-circle";
import ShoppingBag03 from "../../icons/untitled-ui/duocolor/shopping-bag-03";
import AIIcon from "../../icons/untitled-ui/duocolor/aiIcon";
import ImageIcon from '@mui/icons-material/Image';
import Graph from "../../icons/untitled-ui/duocolor/graph";
import AccountingIcon from "../../icons/untitled-ui/duocolor/accountingIcon";
import DashBoardIcon from "../../icons/untitled-ui/duocolor/dashboard";
import {executeQueryUtil} from "../../utils/gqlUtil";
import {getDashBoardQuery, getDashBoardsQuery} from "../../gql/dashBoardGql";

export const useSections = () => {
    const { t } = useTranslation();
    const {currentBrand, superAdmin, userInDb, reloadCustomBoardList} = useAuth();
    const [appItems, setAppItems] = useState([]);
    const [buildingItems, setBuildingItems] = useState([]);

    const [dashBoards, setDashBoards] = useState([]);

    useEffect(() => {
        if (!userInDb) {
            return;
        }
        const getDashBoards = async () => {
            const res = await executeQueryUtil(getDashBoardsQuery(userInDb.id));
            setDashBoards(res.data?.getDashBoards);
        }
        getDashBoards();
    }, [userInDb, reloadCustomBoardList]);


    useEffect(() => {
        setAppItems(getAppItems());
        setBuildingItems(getBuildingItems());
    }, [currentBrand])

    function getAppItems() {
        const items = [
            {
                title: localStrings.establishmentList,
                path: "/" + dashboardBaseRoute + "/" + establishmentListRoute,
                partialMatch: true,
                icon: (
                    <SvgIcon fontSize="small">
                        <Houses/>
                    </SvgIcon>
                )
            },

            {
                title: localStrings.synchronisation,
                path: "/" + dashboardBaseRoute + "/" + synchronisationRoute,
                partialMatch: true,
                icon: (
                    <SvgIcon fontSize="small">
                        <Houses/>
                    </SvgIcon>
                )
            },

            {
                title: localStrings.dashboardRoute,
                path: "/" + dashboardBaseRoute + "/" + dashboardListRoute,
                partialMatch: true,
                icon: (
                    <SvgIcon fontSize="small">
                        <DashBoardIcon/>
                    </SvgIcon>
                )
            },


            // {
            //     title: localStrings.dashboardRoute,
            //     path: "/" + dashboardBaseRoute + "/" + dashboardNavForMobileRoute,
            //     partialMatch: true,
            //     icon: (
            //         <SvgIcon fontSize="small">
            //             <DashBoardIcon/>
            //         </SvgIcon>
            //     )
            // },




        ]

        if (currentBrand()) {
            return items;
        }
        return [];
    }

    function getBuildingItems() {
        const items = []

        if (superAdmin) {
            items.push(
                {
                    title: localStrings.chartImplementationRoute,
                    path: "/" + dashboardBaseRoute + "/" + chartImplementationListRoute,
                    partialMatch: true,
                    icon: (
                        <SvgIcon fontSize="small">
                            <Graph/>
                        </SvgIcon>
                    )
                })
            items.push({
                title: localStrings.chartCategoriesRoute,
                path: "/" + dashboardBaseRoute + "/" + chartCategoryListRoute,
                partialMatch: true,
                icon: (
                    <SvgIcon fontSize="small">
                        <Graph/>
                    </SvgIcon>
                )
            })
            items.push({
                title: localStrings.dataGridImplementationsRoute,
                path: "/" + dashboardBaseRoute + "/" + dataGridImplementationListRoute,
                partialMatch: true,
                icon: (
                    <SvgIcon fontSize="small">
                        <AccountingIcon/>
                    </SvgIcon>
                )
            })
        }

        if (currentBrand()) {
            return items;
        }
        return [];
    }

    return useMemo(() => {

        let items = [
            {
                items: [
                    {
                        title: localStrings.mainDashboard,
                        path: "/" + dashboardBaseRoute,
                        partialMatch: false,
                        icon: (
                            <SvgIcon fontSize="small">
                                <HomeSmile/>
                            </SvgIcon>
                        )
                    },
                    {
                        title: localStrings.account,
                        path: paths.dashboard.account,
                        icon: (
                            <SvgIcon fontSize="small">
                                <Account />
                            </SvgIcon>
                        )
                    },
                    {
                        title: localStrings.myDashboards,
                        icon: (
                            <SvgIcon fontSize="small">
                                <DashBoardIcon/>
                            </SvgIcon>
                        ),
                        items: (dashBoards || []).map((item) => {
                            return  {
                                path: "/" + dashboardBaseRoute + "/" + "customBoards" + "/" + item.id,
                                title: item.name
                            }
                        })
                    },
                ]
            },

            {
                subheader: localStrings.management,
                items: appItems
            },
            {
                subheader: localStrings.data,
                items: [
                    {
                        title: localStrings.accounting,
                        path: "/" + dashboardBaseRoute + "/" + accountingDataRoute,
                        partialMatch: true,
                        icon: (
                            <SvgIcon fontSize="small">
                                <AccountingIcon/>
                            </SvgIcon>
                        )
                    },
                    {
                        title: localStrings.turnover,
                        path: "/" + dashboardBaseRoute + "/" + turnOverDataRoute,
                        partialMatch: true,
                        icon: (
                            <SvgIcon fontSize="small">
                                <CurrencyBitcoinCircle/>
                            </SvgIcon>
                        )
                    },
                    {
                        title: localStrings.staffs,
                        path: "/" + dashboardBaseRoute + "/" + staffDataRoute,
                        partialMatch: true,
                        icon: (
                            <SvgIcon fontSize="small">
                                <Users03/>
                            </SvgIcon>
                        )
                    },
                    {
                        title: localStrings.products,
                        path: "/" + dashboardBaseRoute + "/" + productDataRoute,
                        partialMatch: true,
                        icon: (
                            <SvgIcon fontSize="small">
                                <ShoppingBag03/>
                            </SvgIcon>
                        )
                    },
                    {
                        title: localStrings.aiChat,
                        path: "/" + dashboardBaseRoute + "/" + aiChatDataRoute,
                        partialMatch: true,
                        icon: (
                            <SvgIcon fontSize="small">
                                <AIIcon/>
                            </SvgIcon>
                        )
                    },
                    {
                        title: "Images IA",
                        path: "/" + dashboardBaseRoute + "/" + iaImagesDataRoute,
                        partialMatch: true,
                        icon: (
                            <ImageIcon fontSize="small"/>
                        )
                    },
                ]
            },
            {
                items: [
                    {
                        title: localStrings.termsOfService,
                        path: "/static/termsAndConditions.html",
                        external: true,
                    },
                    {
                        title: localStrings.privacyPolicy,
                        path: "/static/privacyPolicy.html",
                        external: true,
                    },
                ]
            }
        ];

        if (superAdmin) {
            items.splice(1, 0, {
                subheader: localStrings.building,
                items: buildingItems
            })
        }
        return items;
    }, [t, appItems, superAdmin]);
};
